import { TextareaAutosize, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomTextFieldStyle = {
	root: {},
};

export const CustomTextField = styled(TextField)(CustomTextFieldStyle.root);

export const CustomTextareaAutosize = styled(TextareaAutosize)(
	CustomTextFieldStyle.root
);
